module.exports = __webpack_public_path__ + "static/media/adjust.6baed00b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/roi/adjust.jpg
// module id = 3308
// module chunks = 0